import axios from 'axios';

const adminUrl = process.env.VUE_APP_ADMIN_URL;

function headers() {
  const accessToken = JSON.parse(localStorage.getItem('accessToken'));
  return { Authorization: `Bearer ${accessToken}` };
}

// `from`/`to` son opcionales: sin ellos el backend reporta la vigencia completa
// del contrato. Se omiten del request cuando vienen vacíos para no mandar
// parámetros nulos que el backend tendría que interpretar.
function withPeriod(params, from, to) {
  const withDates = { ...params };
  if (from) withDates.from = from;
  if (to) withDates.to = to;
  return withDates;
}

export default class CompanyReportService {
  static async getSummary(contratoId, basis = 'active', from, to) {
    try {
      const response = await axios.get(`${adminUrl}/company-report/${contratoId}/summary`, {
        headers: headers(),
        params: withPeriod({ basis }, from, to),
      });
      if (response.data.status === 'ok') return response.data;
      return { status: 'error' };
    } catch {
      return { status: 'error' };
    }
  }

  static async getUsageDetail(contratoId, section, basis = 'active', from, to) {
    try {
      const response = await axios.get(`${adminUrl}/company-report/${contratoId}/usage-detail`, {
        headers: headers(),
        params: withPeriod({ section, basis }, from, to),
      });
      if (response.data.status === 'ok') return response.data;
      return { status: 'error' };
    } catch {
      return { status: 'error' };
    }
  }

  static async getRejectionReasons(contratoId, basis = 'active', from, to) {
    try {
      const response = await axios.get(`${adminUrl}/company-report/${contratoId}/rejection-reasons`, {
        headers: headers(),
        params: withPeriod({ basis }, from, to),
      });
      if (response.data.status === 'ok') return response.data;
      return { status: 'error' };
    } catch {
      return { status: 'error' };
    }
  }
}
